import React from 'react';
import { BankDetails } from './BankDetails';
import { paymentKind } from './OrderPayment';
import { money } from '../lib/constants';

export const PaymentDestination = ({ order, testId }) => {
  if (paymentKind(order) !== 'transfer') return null;
  if (!order.paymentDestination) return <p data-testid={`${testId}-legacy`} className="text-xs text-gray-500 [overflow-wrap:anywhere]">{order.payment || 'Transferencia bancaria'} · Este pedido anterior no guardó el número de cuenta. Revisa el comprobante.</p>;
  return <section className="space-y-2 min-w-0" data-testid={`${testId}-section`}>
    <BankDetails bank={order.paymentDestination} amount={money(order.total)} compact heading="Cuenta receptora de este pedido" testId={testId} />
    <p data-testid={`${testId}-recipient`} className="text-xs text-gray-500">{order.paymentDestination.owner === 'business' ? 'Pago directo al negocio' : 'Cuenta de la plataforma'}</p>
  </section>;
};